<script setup>
import {onBeforeMount, onMounted, ref, watch} from 'vue';
import {format} from 'date-fns';
import router from "@/router";
import store from "@/store/store";

import EditRequestManagerSideModal from "@/components/modals/EditRequestManagerSideModal.vue";
import EditRequestFitterSideModal from "@/components/modals/EditRequestFitterSideModal.vue";
import axios from "axios";

// let requests = ref([]);
let temp_requests = ref([]);
const is_show_all = ref(false)
//
// // Pagination state
// const next = ref(null);
// const previous = ref(null);
// const count = ref(0);

const temp_next = ref(null);
const temp_previous = ref(null);
const temp_count = ref(0);

const current_page = ref(1);
const page_size = ref("20");

let is_filter_on = ref(true)

let is_fitter = ref(false);
let is_manager = ref(false);
let is_superuser = ref(false);
const formData = ref({
  selected_status_manager: [
    {"id":1,"name":"В работе","isactive":true},
    {"id":4,"name":"Принял в работу монтёр","isactive":true},
    {"id":12,"name":"Выполнен монтёром","isactive":true}
  ],
  selected_status_fitter: [
    {"id":1,"name":"В работе","isactive":true},
    {"id":4,"name":"Принял в работу монтёр","isactive":true},
  ],
  selected_fitter: '',
  // selected_engineer: '',
  selected_manager: '',
  selected_request_type: JSON.stringify([
    {
      type_id: 'd283461c-09b4-430d-b5bd-eba2033ecc54',
      type_name: 'Отключение'
    },
    {
      type_id: '754a15de-c6c9-448a-8487-e94bab389ace',
      type_name: 'Расторжение'
    }
  ]),
  selected_request_kind: {
    kind_id: '',
    kind_name: '',
  },
  selected_area: '',
  selected_street: {
    street_id: ''
  },
  selected_house: {
    house_id: ''
  },
  selected_request_date_start: '',
  selected_request_date_end: '',
});

const loading_page = ref(false);
// const error = ref(null);
let request_statuses = ref([]);
let request_statuses_list_show_edit = ref(['1', "2", "3", '12', '4', '6'])
let fitters_list = ref([]);
// let engineers_list = ref([]);
let managers_list = ref([]);
let areas_streets_array = ref(null);
let request_kinds_types_array = ref(null);
//
// async function fetchNewRequests(limit = 15, offset = 0) {
//   try {
//     loading_page.value = true;
//
//     const response = await axios.get(`all_requests_by_client/?limit=${limit}&offset=${offset}`);
//
//     const requests_data = response.data.results;
//     if (requests_data) {
//       requests.value = requests_data.map(request => ({
//         request_id: request.id,
//         username: request.username,
//         client_name: request.client_name,
//         area: request.area,
//         street: request.street,
//         house: request.house,
//         flat: request.flat,
//         client_address: request.client_address,
//         request_address: request.request_address,
//         request_status_id: request.request_status_id,
//         request_status_name: request.request_status_name,
//         request_type: request.request_type,
//         request_kind: request.request_kind,
//         manager_id: request.manager_id,
//         manager_name: request.manager_name,
//         manager_comment: request.manager_comment,
//         fitter_id: request.fitter_id,
//         fitter_name: request.fitter_name,
//         fitter_comment: request.fitter_comment,
//         date_created: request.date_created,
//         date_expire8: request.date_expire8,
//         date_expire48: request.date_expire48,
//         date_closed: request.date_closed,
//         is_repeated: request.is_repeated,
//       }));
//       temp_requests.value = requests.value;
//       // console.log(temp_requests.value);
//       // console.log("fetch data: "+JSON.stringify(temp_requests.value, null, 2));
//     } else {
//       console.error('Error in the API response.');
//     }
//
//     next.value = response.data.next;
//     temp_next.value = next.value;
//     previous.value = response.data.previous;
//     temp_previous.value = previous.value;
//     count.value = response.data.count;
//     temp_count.value = count.value;
//
//
//   } catch (err) {
//     error.value = err;
//     console.error('Error fetching requests:', err);
//   } finally {
//     loading_page.value = false;
//   }
// }

async function requestFilter(limit = 20, offset = 0) {
  try {
    loading_page.value = true;
    const res = await axios.get(
      `requests_filter/?limit=${limit}&offset=${offset}`, {
        params: {
          request_statuses:
              JSON.stringify(is_fitter && !is_superuser ? formData.value.selected_status_fitter : formData.value.selected_status_manager),
          date_start: '2025-01-01',
          reversed: true
        }
      }
    );
    temp_requests.value = res.data.results.map(request => ({
      request_id: request.id,
      username: request.username,
      client_name: request.client_name,
      area: request.area,
      street: request.street,
      house: request.house,
      flat: request.flat,
      client_address: request.client_address,
      request_address: request.request_address,
      request_status_id: request.request_status_id,
      request_status_name: request.request_status_name,
      request_type: request.request_type,
      request_kind: request.request_kind,
      manager_id: request.manager_id,
      manager_name: request.manager_name,
      manager_comment: request.manager_comment,
      fitter_id: request.fitter_id,
      fitter_name: request.fitter_name,
      fitter_comment: request.fitter_comment,
      date_created: request.date_created,
      date_expire8: request.date_expire8,
      date_expire48: request.date_expire48,
      date_closed: request.date_closed,
      is_repeated: request.is_repeated,
    }));
    temp_next.value = res.data.next
    temp_previous.value = res.data.previous;
    temp_count.value = res.data.count;
    if (!is_filter_on.value) {
      current_page.value = 1;
      is_filter_on.value = true;
    }
  } catch (err) {
    console.error('Error filtering clients:', err);
  } finally {
    loading_page.value = false;
  }
}
function requestTableStatusColor(status, date_expire) {
  const current_date = new Date();
  const expire_date = new Date(date_expire);

  if (
      current_date > expire_date &&
      ((status !== "12") &&
          (status !== "13") &&
          (status !== "5") &&
          (status !== "14"))
  )
  {
    // console.log(current_date > expire_date && (status !== 'Выполнен монтёром' || status !== 'Выполнено'))
    return 'table-red';
  }

  switch (status) {
    case '13':
      return 'table-green';
    case '12':
      return 'table-blue'
    case '5' : case '14':
      return 'table-yellow'
    case '8':
    case '9':
      return 'table-red'
    default:
      return 'table-white'
  }
}

watch(is_show_all, (newValue) => {
  if (newValue === false) {
    page_size.value = 20;
  } else {
    console.log(temp_count.value)
    page_size.value = temp_count.value;
  }
  refreshRequests();
});

const formattedTimestamp = (datetime) => {
  if (!datetime) return ''; // Return empty string if no datetime

  // Try parsing the date
  try {
    const date = new Date(datetime);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ''; // Return empty string for invalid dates
    }

    return format(date, 'dd/MM/yyyy, HH:mm');
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return ''; // Return empty string if parsing fails
  }
};

const goToRequestDetails = (request_id) => {
  router.push({
    name: 'request details',
    query: {request_id}
  });
};
const refreshRequests = () => {
  requestFilter(page_size.value, (current_page.value - 1) * page_size.value)
}


const goToNextPage = () => {
  if (temp_next.value) {
    current_page.value++;
    refreshRequests()
  }
}
onMounted(() => {
  requestFilter(page_size.value, (current_page.value - 1) * page_size.value);
})
const goToPreviousPage = () => {
  if (temp_previous.value) {
    current_page.value--;
    refreshRequests()
  }
}
onBeforeMount(() => {
  is_manager = store.getters['profile/is_manager']
  is_fitter = store.getters['profile/is_fitter']
  is_superuser = store.getters['profile/is_superuser']

})
</script>

<template>
  <div class="content-wrapper">
    <div class="mt-5" style="overflow-x: auto">
      <!-- Table Title -->
      <div class="d-flex align-items-center pt-2 bg-light rounded-3 shadow-sm">
        <!-- Icon -->
        <i class="bi bi-list-task fs-3 text-primary"></i>

        <!-- Title -->
        <h2 class="h4 mb-0 text-primary fw-bold">Активные заявки</h2>

        <!-- Counter -->
        <div class="ms-1 d-flex align-items-center gap-2">
          <div v-if="loading_page" class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="visually-hidden">Загрузка...</span>
          </div>
          <div v-else class="badge bg-primary bg-opacity-10 text-primary fs-5 ">
            <span class="fw-bold">{{ temp_count }}</span>
          </div>
          <!-- Show All Toggle -->
          <div class="form-check form-switch ms-2" v-if="temp_count > 15">
            <input class="form-check-input" role="switch" v-model="is_show_all" type="checkbox" id="showAll">
            <label class="form-check-label">Показать все</label>
          </div>
        </div>
      </div>


      <!-- Loading Spinner -->
      <div v-if="loading_page" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Загрузка...</span>
        </div>
      </div>

      <!-- Table Content -->
      <div v-else>
        <!-- Table -->
        <table class="table table-bordered table-hover">
          <!-- Table Header -->
          <thead class="thead-light">
          <tr>
            <th scope="col" v-if="is_fitter"></th>
            <th scope="col">Менеджер</th>
            <th scope="col">Дата</th>
            <th scope="col">Абонент</th>
            <th scope="col">Адрес</th>
            <th scope="col">Участок</th>
            <th scope="col">Причина</th>
            <th scope="col">Статус</th>
            <th scope="col">Комментарий менеджера</th>
            <th scope="col">Монтер</th>
            <th scope="col">Комментарий монтера</th>
            <th scope="col" v-if="is_manager"></th>
          </tr>
          </thead>

          <!-- Table Body -->
          <tbody>
          <tr
              v-for="request in temp_requests"
              :key="request.id"
              :class="requestTableStatusColor(request.request_status_id, request.date_expire48)"
              class="table-row"
          >
            <!-- Edit Request (Fitter) -->
            <td v-if="is_fitter">
                <span v-if="request.is_repeated === 'True'" class="text-warning">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              <div v-if="request_statuses_list_show_edit.includes(request.request_status_id)">
                <edit-request-fitter-side-modal
                    :request_id="request.request_id"
                    :fitter_id="request.fitter_id"
                    :request_status_id="request.request_status_id"
                    :request_statuses="request_statuses"
                    :fitters_list="fitters_list"
                    :managers_list="managers_list"
                    :areas_streets_array="areas_streets_array"
                    :request_kinds_types_array="request_kinds_types_array"
                    @refresh-requests="refreshRequests"
                ></edit-request-fitter-side-modal>
              </div>
            </td>

            <!-- Manager Name -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.manager_name }}
            </td>

            <!-- Date Created -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ formattedTimestamp(request.date_created) }}
            </td>

            <!-- Client Name -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.client_name }}
            </td>

            <!-- Address -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.street }} {{ request.house }} {{ request.flat }}
            </td>

            <!-- Area -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.area }}
            </td>

            <!-- Request Kind -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              <span v-if="request.is_repeated === 'True' && is_manager" class="text-danger">⚠️</span>
              {{ request.request_kind }}
            </td>

            <!-- Request Status -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.request_status_name }}
            </td>

            <!-- Manager Comment -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.manager_comment }}
            </td>

            <!-- Fitter Name -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.fitter_name }}
            </td>

            <!-- Fitter Comment -->
            <td @click="goToRequestDetails(request.request_id)" class="clickable-cell">
              {{ request.fitter_comment }}
            </td>

            <!-- Edit Request (Manager) -->
            <td v-if="is_manager">
              <div v-if="request_statuses_list_show_edit.includes(request.request_status_id)">
                <edit-request-manager-side-modal
                    :request_id="request.request_id"
                    :manager_id="request.manager_id"
                    :request_statuses="request_statuses"
                    :fitters_list="fitters_list"
                    :managers_list="managers_list"
                    :areas_streets_array="areas_streets_array"
                    :request_kinds_types_array="request_kinds_types_array"
                    @refresh-requests="refreshRequests"
                ></edit-request-manager-side-modal>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <ul class="pagination justify-content-center pb-2">
          <li
              class="page-item"
              :class="temp_previous ? '' : 'disabled'"
              @click="goToPreviousPage"
          >
            <i class="fas fa-solid fa-arrow-left page-link"></i>
          </li>
          <li class="page-item">
            <span class="page-link">Page {{ current_page }} of {{ Math.ceil(temp_count / page_size) }}</span>
          </li>
          <li
              class="page-item"
              :class="temp_next ? '' : 'disabled'"
              @click="goToNextPage"
          >
            <i class="fas fa-solid fa-arrow-right page-link"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Ensure the spinner container takes up the full height */
.content-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Full viewport height */
}

/* Center the spinner */
.d-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Add some spacing and styling to the spinner */
.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>